import "./src/styles/global.css";
import "./src/styles/global.less";
import "dayjs/locale/de";
import dayjs from "dayjs";

dayjs.locale('de')